import { inject, Injectable } from '@angular/core';
import { PlayRecordFormService } from '../play-record-form.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PlayBuilderForm } from './play-builder-form.model';
import { Play } from '@r1-compass-library/models';
import { SelectionCriterionForm } from '@r1-compass-library/models/criteria/selection-criteria-form.model';

export function populatePlayBuilderForm(
    playBuilderForm: FormGroup<PlayBuilderForm>,
    overrideToggleControl: FormControl<boolean | null>,
    play: Play,
    multipleRecommendationsEnabled: boolean | undefined
) {
    // Populate form arrays so they can have their values patched in
    play.config?.criteria?.selectionCriteria.forEach(criterion => {
        playBuilderForm.controls.selectionCriteria.push(
            new FormGroup(new SelectionCriterionForm(criterion.type, criterion))
        );
    });
    // Create new form group to be referenced, using data
    const newFormFromData = new FormGroup(new PlayBuilderForm(play.templateCriteriaId, play.config?.criteria));
    // Patch existing form being referenced
    playBuilderForm.patchValue(newFormFromData.getRawValue());

    if (multipleRecommendationsEnabled) {
        if (playBuilderForm.controls.overrideMultipleRecommendationsQuery.value) {
            overrideToggleControl.patchValue(true);
            playBuilderForm.controls.overrideMultipleRecommendationsQuery.addValidators(Validators.required);
            playBuilderForm.controls.overrideMultipleRecommendationsQuery.updateValueAndValidity();
        } else {
            playBuilderForm.controls.overrideMultipleRecommendationsQuery.disable();
        }
        playBuilderForm.controls.overrideStandardQuery.disable();
    } else {
        if (playBuilderForm.controls.overrideStandardQuery.value) {
            overrideToggleControl.patchValue(true);
            playBuilderForm.controls.overrideStandardQuery.addValidators(Validators.required);
            playBuilderForm.controls.overrideStandardQuery.updateValueAndValidity();
        } else {
            playBuilderForm.controls.overrideStandardQuery.disable();
        }
        playBuilderForm.controls.overrideMultipleRecommendationsQuery.disable();
    }
    playBuilderForm.markAllAsTouched();
}

@Injectable()
export class PlayBuilderFormService {
    readonly #playRecordFormService = inject(PlayRecordFormService);

    public playBuilderForm: FormGroup<PlayBuilderForm> = this.#playRecordFormService.playBuilderForm;

    public overrideToggleControl = new FormControl<boolean | null>(false);

    public populatePlayBuilderForm(
        playBuilderForm: FormGroup<PlayBuilderForm>,
        overrideToggleControl: FormControl<boolean | null>,
        play: Play,
        multipleRecommendationsEnabled: boolean | undefined
    ) {
        populatePlayBuilderForm(playBuilderForm, overrideToggleControl, play, multipleRecommendationsEnabled);
    }
}
